import * as labels from "@ax/office-resources-common";

/** Manages the loading and resolution of labels. */
export class LabelLoader extends labels.LabelLoader {

    /**
     * Gets the resource file prefixes.
     *
     * @param pathSegment Language-specific portion of the filename
     * @returns The array of resource file prefixes.
     */
    protected loadResourceFiles(pathSegment: string): Promise<labels.MessageFile[]> {
        return Promise.all([
            import(/* webpackChunkName: "[request]"*/ `@ax/office-cdn-app-resources/src/messages/DynamicsAppResources${pathSegment}.resjson`)
        ]);
    }
}

/** Manages the loading and resolution of labels for the PowerApps add-in. */
export class PowerAppsLabelLoader extends labels.LabelLoader {

    /**
     * Gets the resource file prefixes.
     *
     * @param pathSegment Language-specific portion of the filename
     * @returns The array of resource file prefixes.
     */
    protected loadResourceFiles(pathSegment: string): Promise<labels.MessageFile[]> {
        return Promise.all([
            import(/* webpackChunkName: "[request]"*/ `@ax/office-cdn-app-resources/src/messages/DynamicsAppResources${pathSegment}.resjson`),
            import(/* webpackChunkName: "[request]"*/ `@ax/office-cdn-app-resources/src/messages/PowerAppsResources${pathSegment}.resjson`)
        ]);
    }
}
